export default __webpack_public_path__ + "static/media/chain-21.bbc7f2ef.png";